import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import main from './sass/main.scss'

require ('./assets/fontLoader.css')
require('@/assets/styles.css')

Vue.config.productionTip = false


// plugins
import axios from '@/plugins/axios'
Vue.use(axios)
Vue.prototype.$axios =  axios

// Impersonation header — added here (not in axios.js) to avoid circular dep
// store imports axios plugin; so we hook both together here in main.js
axios.interceptors.request.use(function(config) {
    const imp = store.state?.ImpersonatingUser
    if (imp?.ISMID) {
        config.headers['X-Impersonate-As'] = imp.ISMID
    }
    return config
})

// Pusher/Echo websocket disabled — was triggering Chrome's "Access other
// devices on your local network" prompt by connecting to a private-network
// host. Notifications still refresh via polling on drawer toggle.
// import Echo from 'laravel-echo';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//   broadcaster: 'pusher',
//   key: process.env.MIX_PUSHER_APP_KEY || "app-key",
//   wsHost: process.env.MIX_PUSHER_HOST || 'staff.pgo.mv',
//   wsPort: process.env.MIX_PUSHER_PORT || 6002,
//   wssPort: process.env.MIX_PUSHER_PORT || 6002,
//   forceTLS: false,
//   encrypted: true,
//   disableStats: true,
//   enabledTransports: ['ws', 'wss'],
//   cluster: 'mt1',
// });


import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast)

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
Vue.use(DatePicker)


import NewSelect from '@/components/util/new_select/NewSelect.vue';
Vue.component('new-select', NewSelect)

import NewSelectRemote from '@/components/util/new_select/NewSelectRemote.vue';
Vue.component('new-select-remote', NewSelectRemote)


import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultHtml: false,
})
// Vue.directive('tooltip', VTooltip.VTooltip)

//mixins
import { userMixin } from '@/mixins/user.mixin'
import { utilMixin } from './mixins/utils.mixin.js'
Vue.mixin(userMixin).mixin(utilMixin)

var filter = function(text, length, clamp, from){
  clamp = clamp || '...';
  from = from || 'e'
  if(from == 's'){
    return text.length > length ?  clamp + text.slice(length) : text;
  }
  return text.length > length ? text.slice(0, length) + clamp : text;
};

Vue.filter('truncate', filter);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
